var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.$route.meta.title,"left-text":"","left-arrow":""},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"ellipsis"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }